import { Hsva, Rgba } from 'ngx-color-picker';
import * as ngxColor from 'ngx-color-picker';

export function rgbaToString(rgba: Rgba): string {
    return `${Object.keys(rgba).join('')}(${Object.values(rgba).join(', ')})`;
}

export function kelvinToRgba(temp: number, a: number = 1): Rgba {
    temp = temp / 100;
    let r: number;
    let g: number;
    let b: number;

    if (temp <= 66) {
      r = 255;
    } else {
      r = temp - 60;
      r = 329.698727466 * Math.pow(r, -0.1332047592);
      if (r < 0) {
        r = 0;
      }
      if (r > 255) {
        r = 255;
      }
    }

    if (temp <= 66) {
      g = temp;
      g = 99.4708025861 * Math.log(g) - 161.1195681661;
      if (g < 0) {
        g = 0;
      }
      if (g > 255) {
        g = 255;
      }
    } else {
      g = temp - 60;
      g = 288.1221695283 * Math.pow(g, -0.0755148492);
      if (g < 0) {
        g = 0;
      }
      if (g > 255) {
        g = 255;
      }
    }

    if (temp >= 66) {
      b = 255;
    } else {
      if (temp <= 19) {
        b = 0;
      } else {
        b = temp - 10;
        b = 138.5177312231 * Math.log(b) - 305.0447927307;
        if (b < 0) {
          b = 0;
        }
        if (b > 255) {
          b = 255;
        }
      }
    }
    return new Rgba(r, g, b, a);
  }

  export function kelvinToRgbaString(kelvinValue: number): string {
    return rgbaToString(kelvinToRgba(kelvinValue));
  }

  export function brightnessToRgbaString(value: number, max: number): string {
    const colorService = new ngxColor.ColorPickerService();
    const whiteHsva = new Hsva(0, 0, 1, 1);
    whiteHsva.v *= value / max;
    return rgbaToString(colorService.denormalizeRGBA(colorService.hsvaToRgba(whiteHsva)));
  }

  export function getRandomDarkColor(): string {
    const colorService = new ngxColor.ColorPickerService();
    const r: number = Math.floor(Math.random() * 255);
    const g: number = Math.floor(Math.random() * 255);
    const b: number = Math.floor(Math.random() * 255);
    const rgba = new Rgba(r, g, b, 1);
    const cmyk = colorService.rgbaToCmyk(rgba);
    cmyk.k = -180;
    return colorService.rgbaToHex(colorService.cmykToRgb(cmyk));
  }

